import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ContactlessIcon(props: IconProps) {
    return <Icon {...props} iconKey={"contactless"}/>
}
